import request from '@/utils/request'

// 注册
export function regeister(data) {
  return request({
    url: '/proxyApi/regist',
    method: 'post',
    data,
  })
}
// 登录
export function login_fetch(data) {
  return request({
    url: '/proxyApi/login',
    method: 'post',
    data,
  })
}
// 当前用户信息
export function userInfos(data) {
  return request({
    url: '/proxyApi/userInfo',
    method: 'post',
    data,
  })
}
// 修改密码
export function changePas(data) {
  return request({
    url: '/proxyApi/updatePassword',
    method: 'post',
    data,
  })
}
// 订单列表
export function orderList(data) {
  return request({
    url: '/proxyApi/findByUserId',
    method: 'post',
    data,
  })
}
// sure card
// export function changeCard(data) {
//   return request({
//     url: '/proxyApi/findByUserId',
//     method: 'post',
//     data,
//   })
// }
